window.afterPageLoad = function () {
  deleteButtons()
  removeButtons()
  const blur = document.querySelector('.blur')
  if (blur) {
    blur.classList.remove('blur')
  }

  simpleMaskMoney()
}

window.simpleMaskMoney = function () {
  document.querySelectorAll('.currency-input').forEach(currency => {
    const options = {
      prefix: '',
      suffix: '',
      fixed: true,
      fractionDigits: 2,
      decimalSeparator: ',',
      thousandsSeparator: '.',
      autoCompleteDecimal: true
    }

    currency.mask = SimpleMaskMoney.setMask('#' + currency.id, options)
  })
}

$.extend(true, $.fn.dataTable.defaults, {
  language: {
    url: 'https://cdn.datatables.net/plug-ins/1.10.22/i18n/Spanish.json',
    buttons: {
      copy: 'Copiar',
      copySuccess: {
        _: 'Copiado %d registros',
        1: 'Copiado 1 registro'
      },
      print: 'Imprimir',
      colvis: 'Editar columnas',
      colvisRestore: 'Restaurar Columnas',
      pageLength: {
        _: 'Mostrar %d registros',
        '-1': 'Todos los registros'
      }
    }
  },
  order: [
    [0, 'desc']
  ],
  responsive: true,
  paging: true,
  dom: 'Bfrtip',
  processing: true,
  serverSide: true,
  lengthMenu: [
    [20, 50, 100, 300],
    [20, 50, 100, 300]
  ],
  buttons: [],
  drawCallback: function (settings) {
    afterPageLoad()
  }
})

window.datatableButtons = [{
  extend: 'excel',
  text: 'Excel',
  exportOptions: {
    modifier: {
      page: 'all',
      search: 'none'
    },
    columns: [0, 1, 2, 3, 4, 5, 6, 7, 8]
  }
},
'print',
'pageLength',
{
  text: 'Actualizar',
  action: function (e, dt, node, config) {
    dt.ajax.reload(null, false)
  }
}
]

function filterColumn (i) {
  $('table.table').DataTable().column(i).search(
    $('#col' + i + '_filter').val()
  ).draw()
}

window.hideModal = function (modal) {
  $(modal).modal('hide')
  modal.querySelector('form') ? modal.querySelector('form').reset() : ''
}

window.showModal = function (modal) {
  $(modal).modal()
}

$('select.column_filter').on('change', function () {
  filterColumn($(this).attr('data-column'))
})

window.resetModalForm = function () {
  $('.modal').on('hidden.bs.modal', function (e) {
    // Checkboxes/radios: val('') les pisa el atributo value (p.ej. value="1") y el
    // fill de reapertura solo restaura checked, así que el submit pasaría a mandar
    // "" (falsy en el backend, borraba divides_commission). Se desmarcan en cambio.
    $(this).find('input:not(.no-reset)').not('[type=hidden], [type=checkbox], [type=radio]').val('')
    $(this).find('input[type=checkbox]:not(.no-reset), input[type=radio]:not(.no-reset)').prop('checked', false)
    $(this).find('select:not(.no-reset)').val('')
    $(this).find('.message:not(.no-reset)').text('')
    $(this).find('[name=quantity]').val(1)
    $(this).find('[name=price]').val('0,00')
    $(this).find('[name=amount]').val('0,00')

    this.querySelectorAll('.select__slim').forEach(select => {
      if (select.variable) {
        select.variable.set('')
      }
    })
  })
}

$('#confirmPopup').on('hidden.bs.modal', function (e) {
  const el = document.querySelector('#confirmPopup #confirm')
  const elClone = el.cloneNode(true)
  el.parentNode.replaceChild(elClone, el)
})

window.confirmPopup = function (title, body, eFunc) {
  const modal = document.getElementById('confirmPopup')
  modal.querySelector('.modal-title').innerText = title
  modal.querySelector('.modal-body').innerHTML = body

  showModal(modal)
  modal.querySelector('#confirm').removeEventListener('click', function () {
  })
  modal.querySelector('#confirm').addEventListener('click', function () {
    eFunc()
    hideModal(document.getElementById('confirmPopup'))
  })
}

window.serializeForm = function (form) {
  let currencyField = ''
  if (form.querySelector('.currency-input')) {
    currencyField = form.querySelectorAll('.currency-input')
  }

  const obj = {}
  let currencyKey = false
  const formData = new FormData(form)
  for (const key of formData.keys()) {
    currencyKey = false
    if (key.includes('[]')) {
      obj[key.replace('[]', '')] = formData.getAll(key)
    } else {
      const rawValue = formData.get(key)
      if (rawValue instanceof File && rawValue.size === 0 && rawValue.name === '') {
        continue
      }
      if (currencyField) {
        currencyField.forEach(currency => {
          if (currency.name === key) {
            currencyKey = currency
          }
        })

        if (currencyKey) {
          obj[key] = currencyKey.mask.formatToNumber()
        } else {
          obj[key] = rawValue
        }
      } else {
        obj[key] = rawValue
      }
    }
  }

  return obj
}

/**
 * Función genérica para cargar opciones en selects.
 * @param {string} selector - Selector CSS del select (ej: 'select[name=customer_id]')
 * @param {string|null} url - URL del API (null si los datos son estáticos)
 * @param {Function} mapFn - Función que recibe un item y retorna {value, text}
 * @param {string} placeholder - Texto del placeholder
 * @param {Array|null} staticData - Datos estáticos (si no hay URL)
 * @param {Object} options - Opciones adicionales: {slim: false, slimAddable: false}
 */
window.loadSelect = function (selector, url, mapFn, placeholder = 'Elija una opción', staticData = null, options = {}) {
  const select = document.querySelectorAll(selector)

  function populateSelect (data) {
    let optionHtml = `<option value="" disabled selected>${placeholder}</option>`
    data.forEach(item => {
      const mapped = mapFn(item)
      optionHtml += `<option value="${mapped.value}">${mapped.text}</option>`
    })
    select.forEach(s => { s.innerHTML = optionHtml })

    if (options.slim) {
      select.forEach(s => {
        s.classList.remove('form-control')
        s.classList.add('select__slim')
        const slimConfig = {
          select: s,
          searchPlaceholder: options.slimPlaceholder || 'Buscar',
          searchText: 'No se ha encontrado nada',
          searchFocus: false,
          searchHighlight: true
        }
        if (options.slimAddable) {
          slimConfig.searchText = 'No se encontró. Presione Enter para crear nuevo.'
          slimConfig.addable = function (value) {
            return { text: value, value: 'new:' + value }
          }
        }
        s.variable = new SlimSelect(slimConfig)
      })
    }
  }

  if (staticData) {
    populateSelect(staticData)
  } else if (url) {
    axios.get(url).then(response => populateSelect(response.data))
  }
}

window.loadDocumentTypes = function () {
  loadSelect('select[name=document_type_id]', '/api/documentos', d => ({ value: d.id, text: d.short_name }))
}

window.loadPaymentTypes = function () {
  loadSelect('select[name=payment_type_id]', '/api/tipos-de-pagos', t => ({ value: t.id, text: ucfirst(t.name) }))
}

window.loadBalanceTypes = function () {
  loadSelect('select[name=balance_type_id]', null, t => ({ value: t.id, text: ucfirst(t.name) }), 'Elija una opción',
    [{ name: 'Debe', id: 1 }, { name: 'Haber', id: 2 }])
}

window.loadRoles = function () {
  loadSelect('select[name^=roles]', '/api/roles', r => ({ value: r.name, text: ucfirst(r.name) }))
}

window.loadPermissions = function () {
  loadSelect('select[name=permissions]', '/api/permisos', p => ({ value: p.name, text: ucfirst(p.name) }))
}

window.loadArticles = function () {
  loadSelect('select[name=article_id]', '/api/articles', a => ({ value: a.id, text: ucfirst(a.name) }), 'Elija un articulo', null, { slim: true })
}

window.loadExpenditureTypes = function () {
  loadSelect('select[name=expenditure_type_id]', '/api/gastos-tipos', t => ({ value: t.id, text: ucfirst(t.name) }), 'Elija un tipo de gasto', null, { slim: true })
}

window.loadArticlesForStatistics = function () {
  loadSelect('select[name=article_id]', '/api/articlesForStatistics', a => ({ value: a.id, text: ucfirst(a.name) }), 'Elija un articulo', null, { slim: true })
}

window.loadSupplies = function () {
  loadSelect('select[name=supply_id]', '/api/insumos', s => ({ value: s.id, text: ucfirst(s.name) }), 'Elija un insumo o escriba uno nuevo', null, {
    slim: true, slimAddable: true, slimPlaceholder: 'Buscar o escribir nuevo insumo'
  })
}

window.selectSlim = function (variable, select) {
  select = document.querySelectorAll('select[name=' + select + ']')
  select.forEach(s => {
    s.classList.remove('form-control')
    s.classList.add('select__slim')
    s.variable = new SlimSelect({
      select: s,
      searchPlaceholder: 'Buscar',
      searchText: 'No se ha encontrado nada',
      searchFocus: false,
      searchHighlight: true
    })
  })
}

window.loadCustomers = function () {
  loadSelect('select[name=customer_id]', '/api/clientes', c => ({ value: c.id, text: ucfirst(c.name) }), 'Seleccione un cliente', null, { slim: true })
}

window.loadEmployees = function () {
  loadSelect('select[name=employee_id]', '/api/empleados', e => ({ value: e.id, text: ucfirst(e.name) }), 'Seleccione un empleado', null, { slim: true })
}

window.loadSuppliers = function () {
  loadSelect('select[name=supplier_id]', '/api/proveedores', s => ({ value: s.id, text: ucfirst(s.name) }), 'Seleccione un proveedor', null, { slim: true })
}

window.loadIvaCondition = function () {
  loadSelect('select[name=iva]', null, c => ({ value: c.value, text: c.name }), 'Seleccione el IVA',
    [{ value: 0, name: '0%' }, { value: 10.5, name: '10.5%' }, { value: 21, name: '21%' }, { value: 27, name: '27%' }])
}

window.loadTaxConditions = function () {
  const select = document.querySelectorAll('select[name=tax_condition_id]')
  axios.get('/api/tax_conditions').then(function (response) {
    let option = '<option value="" disabled selected>Seleccione una condición</option>'
    Object.entries(response.data).forEach(([key, val]) => {
      option += `<option value="${key}">${val}</option>`
    })
    select.forEach(s => { s.innerHTML = option })
  })
}

window.loadPatientsByCustomers = function () {
  const customerSelect = document.querySelector('select[name=customer_id]')

  customerSelect.addEventListener('change', function () {
    if (!customerSelect.value) {
      document.querySelectorAll('select[name=patient_id]').forEach(s => {
        s.innerHTML = ''
      })
    } else {
      window.newPatientBtn.disabled = false
      document.querySelector('#newPatientBtnModal input[name=customer_id]').value = customerSelect.value
      fillPatientSelect(customerSelect.value)
    }
  })
}

window.fillPatientSelect = function (customer_id, select_last = false) {
  const patientSelect = document.querySelectorAll('select[name=patient_id]')

  patientSelect.forEach(s => {
    s.innerHTML = '<option value="" disabled selected>Seleccione un paciente</option>'
  })

  axios.get('/api/clientes/json/getPatients/' + customer_id)
    .then(function (response) {
      let option = '<option value="" disabled selected>Seleccione un paciente</option>'

      response.data.forEach(function (patient) {
        option += `<option value="${patient.id}" ${select_last ? 'selected' : ''}>${ucfirst(patient.name)}</option>`
      })

      patientSelect.forEach(s => {
        s.innerHTML = option
      })
    })
}

window.ucfirst = (string) => string.charAt(0).toUpperCase() + string.slice(1)
window.formatDate = function (date, datetime = false) {
  if (date) {
    if (datetime) {
      const dateParts = date.split(' ')
      const datePart = dateParts[0].split('-')
      const day = new Date(datePart[0], datePart[1] - 1, datePart[2])

      return date
        ? day.toLocaleDateString('es-AR', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
          }) + ' ' + dateParts[1]
        : ''
    }

    const dateParts = date.replace(' ', 'T').split('T')[0].split('-')
    const day = new Date(dateParts[0], dateParts[1] - 1, dateParts[2])

    return date ? day.toLocaleDateString('es-AR', { year: 'numeric', month: '2-digit', day: '2-digit' }) : ''
  }

  return ''
}

window.formatDateForInput = function (date) {
  date = new Date(date)
  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()

  return `${year}-${`${month}`.padStart(2, '0')}-${`${day}`.padStart(2, '0')}`
}

window.firstOfMonth = function () {
  const date = new Date()
  const year = date.getFullYear()
  const month = date.getMonth()

  return new Date(year, month, 1)
}

window.getToday = function () {
  return new Date()
}

window.formatPrice = function (price) {
  return numeral(price * 1).format('$0,0.00')
}

// Neto de un item de compra: precio unitario por cantidad, con el descuento (%)
// aplicado. Espejo JS de PurchaseItem::netAmountSql() — mantener en sincronía.
window.purchaseItemNet = function (price, quantity, discount) {
  price = parseFloat(price) || 0
  quantity = parseFloat(quantity) || 0
  discount = Math.min(Math.max(parseFloat(discount) || 0, 0), 100)
  return price * quantity * (1 - discount / 100)
}

// Neto del item más su IVA. Espejo JS de PurchaseItem::totalAmountSql().
window.purchaseItemTotal = function (price, quantity, discount, iva) {
  const net = window.purchaseItemNet(price, quantity, discount)
  return net + net * ((parseFloat(iva) || 0) / 100)
}

window.months = {
  1: 'Enero',
  2: 'Febrero',
  3: 'Marzo',
  4: 'Abril',
  5: 'Mayo',
  6: 'Junio',
  7: 'Julio',
  8: 'Agosto',
  9: 'Septiembre',
  10: 'Octubre',
  11: 'Noviembre',
  12: 'Diciembre'
}

window.shortMonths = {
  1: 'Ene',
  2: 'Feb',
  3: 'Mar',
  4: 'Abr',
  5: 'Mayo',
  6: 'Jun',
  7: 'Jul',
  8: 'Ago',
  9: 'Sep',
  10: 'Oct',
  11: 'Nov',
  12: 'Dic'
}

window.formatOrderNumber = function (number) {
  return `#${`${number}`.padStart(6, '0')}`
}

/* Refresh all DataTables on the page */
window.refresh = function () {
  $.fn.dataTable.tables({ visible: true, api: true }).ajax.reload(null, false)
}

/* delete methods */
window.deleteModel = function (model, id) {
  axios.delete(`/api/${model}/${id}`)
    .then(function (response) {
      refresh()
      if (typeof reloadPage === 'function') {
        reloadPage()
      }
      showNotification(response.data ? response.data.message : 'Borrado exitoso')
    })
    .catch(function (error) {
      showNotification(error.response ? error.response.data.message : 'Ha ocurrido un error inesperado', 'danger')
    })
}

window.deleteOrder = function (id) {
  deleteModel('trabajos', id)
}

window.deleteOrderItem = function (id) {
  deleteModel('trabajos-item', id)
}

window.deletePatient = function (id) {
  deleteModel('pacientes', id)
}

window.deleteImage = function (id) {
  deleteModel('imagen', id)
}

window.deleteCustomer = function (id) {
  deleteModel('clientes', id)
}

window.deleteCustomerPayments = function (id) {
  if (confirm('¿Seguro de borrar el pago #' + id + '?')) {
    deleteModel('pagos', id)
    refresh()
  }
}

window.deleteSupplierPayments = function (id) {
  if (confirm('¿Seguro de borrar el pago #' + id + '?')) {
    deleteModel('pagos-proveedores', id)
    refresh()
  }
}

window.deleteSupplier = function (id) {
  deleteModel('proveedores', id)
}

window.deleteCustomerBalance = function (id) {
  deleteModel('customer_balance', id)
}

window.deletePayment = function (id) {
  deleteModel('pagos', id)
}

window.deleteButtons = function () {
  document.querySelectorAll("button[data-method='delete']").forEach(button => {
    button.addEventListener('click', function () {
      const data = button.dataset
      confirmPopup(
        data.title,
        data.body,
        () => deleteModel(data.model, data.id))
    })
  })
}

window.removeButtons = function () {
  document.querySelectorAll('[data-can]').forEach(function (node) {
    if (!userCan(node.dataset.can)) {
      node.remove()
    }
  })
}

window.showNotification = function (title, type = 'success') {
  document.getElementById('notifications')
    .innerHTML = `<div class="alert alert-${type}" role="alert">
        ${title}
        <button type="button" class="close" data-dismiss="alert" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>`

  setTimeout(() => {
    if (document.querySelector('.alert')) {
      document.querySelector('.alert').remove()
    }
  }, 3000)
}

window.closeOrderConfirmation = (title, body, id) => confirmPopup(title, body, () => closeOrder(id))
window.openOrderConfirmation = (title, body, id) => confirmPopup(title, body, () => openOrder(id))
window.closePurchaseConfirmation = (title, body, id) => confirmPopup(title, body, () => closePurchase(id))
window.closeCreditNoteConfirmation = (title, body, id) => confirmPopup(title, body, () => closeCreditNote(id))
window.deleteCreditNoteConfirmation = (id) => confirmPopup(
  '¿Estás seguro?',
  '¿Estás seguro de eliminar esta nota de crédito? Esta acción también eliminará el impacto en el balance del proveedor.',
  () => {
    axios.delete(`/api/notas-de-credito/${id}`)
      .then(function (response) {
        showNotification(response.data.message)
        setTimeout(() => { window.location.href = '/notas-de-credito' }, 1000)
      })
      .catch(function (error) {
        showNotification(error.response ? error.response.data.message : 'Ha ocurrido un error inesperado', 'danger')
      })
  }
)
window.sendPasswordEmailConfirmation = (title, body, id) => confirmPopup(title, body, () => sendPasswordEmail(id))
/**
 * Helper para acciones API con manejo de errores unificado.
 * @param {string} url - URL del endpoint
 * @param {Function|null} onSuccess - Callback extra tras éxito (además de showNotification)
 */
window.apiAction = function (url, onSuccess = null) {
  axios.get(url)
    .then(function (response) {
      showNotification(response.data.message)
      if (onSuccess) onSuccess(response)
    })
    .catch(function (error) {
      showNotification(error.response ? error.response.data.message : 'Ha ocurrido un error inesperado', 'danger')
    })
}

window.sendPasswordEmail = function (id) {
  apiAction('/api/sendPasswordEmail/' + id)
}

window.closeOrder = function (id) {
  apiAction('/api/trabajos/' + id + '/close', () => loadOrder())
}

window.openOrder = function (id) {
  apiAction('/api/trabajos/' + id + '/open', () => loadOrder())
}

window.closePurchase = function (id) {
  apiAction('/api/compras/' + id + '/close', () => { afterPageLoad(); loadPurchase() })
}

window.closeCreditNote = function (id) {
  apiAction('/api/notas-de-credito/' + id + '/close', () => { afterPageLoad(); loadCreditNote() })
}

window.userCan = function (permission) {
  return window.Laravel.user.can[permission]
}

window.fillEditModal = function (url, modalName = 'editModal') {
  const modal = document.getElementById(modalName)
  modal.querySelector('p').innerText = ''
  axios.get(url)
    .then(function (response) {
      Object.keys(response.data).forEach(key => {
        if (key === 'roles') {
          response.data[key].forEach(r => {
            if (modal.querySelector('[name^=roles]') && modal.querySelector('[name^=roles]').multiple) {
              Array.prototype.forEach.call(modal.querySelector('[name^=roles]').options, function (option) {
                if (option.value === r.name) { option.selected = true }
              })
            }
          })
        } else {
          const $input = modal.querySelector('[name=' + key + ']')

          if ($input) {
            switch ($input.type) {
              case 'checkbox':
                $input.checked = response.data[key]
                break
              case 'select-one':
                if ($input.variable) {
                  $input.variable.set(response.data[key])
                } else {
                  Array.prototype.forEach.call($input.options, function (option) {
                    if (option.value * 1 === response.data[key]) { option.selected = true }
                  })
                }
                break
              case 'file':
                break
              default:
                $input.value = response.data[key]
                break
            }
          }
        }
      })
      modal.querySelector('form').action = url
      simpleMaskMoney()
    })
  showModal(modal)
}

window.paymentModalListener = function () {
  document.querySelectorAll('select[name=payment_type_id]').forEach(select => {
    select.addEventListener('change', function () {
      checkSelect(select)
    })

    checkSelect(select)
  })

  function checkSelect (select) {
    if (select.value == 1) {
      select.parentElement.parentElement.querySelector('[for=description]').innerHTML = 'Descripción'
      select.parentElement.parentElement.querySelector('[name=description]').required = false
      select.parentElement.parentElement.querySelector('[name=description]').placeholder = ''
    } else if (select.value == 2) {
      select.parentElement.parentElement.querySelector('[for=description]').innerHTML = 'Descripción <span class="required">Requerido</span>'
      select.parentElement.parentElement.querySelector('[name=description]').required = true
      select.parentElement.parentElement.querySelector('[name=description]').placeholder = 'Ej. Nombre del banco'
    } else if (select.value == 3) {
      select.parentElement.parentElement.querySelector('[for=description]').innerHTML = 'Descripción <span class="required">Requerido</span>'
      select.parentElement.parentElement.querySelector('[name=description]').required = true
      select.parentElement.parentElement.querySelector('[name=description]').placeholder = 'Ej. Nombre del banco y Número de cheque'
    }
  }
}

window.createEditModal = function (inputs, title, modalName = 'editModal') {
  document.querySelector('.modals').innerHTML += modalTemplate(modalName, 'PUT')
  const modal = document.getElementById(modalName)
  modal.querySelector(`#${modalName}Label`).innerText = title

  inputs.forEach(input => {
    modal.querySelector('.modal-body .inputs').innerHTML += inputTemplate(input)
  })

  modal.querySelector('.modal-body').innerHTML += `<div class="form-group">
                        <p class="text-danger message"></p>
                    </div>`
}

window.createNewModal = function (inputs, url, title, modalName = 'newModal') {
  document.querySelector('.modals').innerHTML += modalTemplate(modalName)
  const modal = document.getElementById(modalName)
  modal.querySelector('form').action = url
  modal.querySelector(`#${modalName}Label`).innerText = title

  inputs.forEach(input => {
    modal.querySelector('.modal-body .inputs').innerHTML += inputTemplate(input)
  })
  resetModalForm()
}

window.submitModal = function (e) {
  e.preventDefault()

  const modal = e.target.parentElement.parentElement
  const form = modal.querySelector('form')
  const url = form.action
  let data = serializeForm(form)
  let headers = {
    'Content-Type': 'application/json'
  }

  let multipart = false

  Object.entries(data).forEach(([key, value]) => {
    if (typeof value === 'object') {
      multipart = true
    }
  })

  if (multipart) {
    const formData = new FormData(form)
    headers = {
      'Content-Type': 'multipart/form-data'
    }

    data = formData

    // Display the key/value pairs
    for (const pair of data.entries()) {
      if (['amount', 'net_amount', 'price', 'iibb', 'iva', 'other_taxes'].includes(pair[0])) { // } === 'net_amount' || pair[0] === 'amount' || pair[0] === 'price') {
        data.set(pair[0], pair[1].replaceAll('.', '').replaceAll(',', '.'))
      }
    }
  }

  axios.post(url, data, {
    headers: headers
  })
    .then(function (response) {
      if (response.data.printRedirect) {
        showNotification(response.data.message + ', redirigiendo a pantalla de impresión..')
        setTimeout(() => {
          window.open(response.data.printRedirect, '_blank')
        }, 1000)
      }

      hideModal(modal)
      if (typeof refresh === 'function') {
        refresh()
      }

      showNotification(response.data.message)

      if (typeof reloadPage === 'function') {
        reloadPage()
      }

      if (response.data.redirect) {
        showNotification(response.data.message + ', redirigiendo a la pantalla de compra..')
        setTimeout(() => {
          document.location.href = response.data.redirect
        }, 2000)
      }
    })
    .catch(err => {
      const error = extractError(err)

      if (modal.querySelector('.message')) {
        modal.querySelector('.message').innerText = error
      } else {
        showNotification(error, 'danger')
      }
    })
}

window.extractError = function (error) {
  let result, fatalError

  if (error.response) {
    if (error.response.data.error) {
      result = error.response.data.error + '!'
    } else if (error.response.data.errors && error.response.data.errors.password) {
      result = error.response.data.errors.password.map(error => error).join(', ')
    } else if (error.response.data.message) {
      result = error.response.data.message
    } else {
      fatalError = true
      result = 'Internal error!'
    }
  } else {
    fatalError = true
    result = 'Ha ocurrido un error inesperado'
  }

  if (fatalError) {
    axios.post('/api/error-log', {
      message: error.response
    })
  }

  return result
}

window.submitEditModal = function (e) {
  e.preventDefault()

  const modal = e.target.parentElement.parentElement
  const form = modal.querySelector('form')
  const url = form.action
  let data = serializeForm(form)
  let headers = {
    'Content-Type': 'application/json'
  }
  let httpMethod = 'put'

  // Sólo enviamos multipart cuando realmente se seleccionó un archivo.
  // (serializeForm ya omite los inputs file vacíos, así que editar sin
  // adjuntar archivo nunca manda un valor inválido que rompa la validación.)
  const hasFile = Object.values(data).some(value => value instanceof File)

  if (hasFile) {
    const formData = new FormData(form)
    // Method spoofing: el endpoint update es PUT y PHP sólo puebla los
    // archivos en requests POST, así que mandamos POST + _method=PUT.
    formData.append('_method', 'PUT')
    headers = {
      'Content-Type': 'multipart/form-data'
    }

    for (const pair of formData.entries()) {
      if (['amount', 'net_amount', 'price', 'iibb', 'iva', 'other_taxes'].includes(pair[0])) {
        formData.set(pair[0], pair[1].replaceAll('.', '').replaceAll(',', '.'))
      }
    }

    data = formData
    httpMethod = 'post'
  }

  axios[httpMethod](url, data, { headers })
    .then(response => {
      hideModal(modal)
      refresh()
      showNotification(response.data.message)
      if (typeof reloadPage === 'function') {
        reloadPage()
      }
    })
    .catch(err => {
      const error = extractError(err)

      if (modal.querySelector('.message')) {
        modal.querySelector('.message').innerText = error
      } else {
        showNotification(error, 'danger')
      }
    })
}

window.cleanModalForm = function (id) {
  const modal = document.getElementById(id)
  modal.querySelector('form').reset()
  simpleMaskMoney()
}

window.downloadFile = function (path, fileName) {
  axios({
    url: path,
    method: 'GET',
    responseType: 'blob'
  }).then((response) => {
    const url = window.URL.createObjectURL(new Blob([response.data]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', fileName)
    document.body.appendChild(link)
    link.click()
  })
}

window.popupCenter = function (url, title, w = 750, h = 750) {
  const left = (screen.width / 2) - (w / 2)
  const top = (screen.height / 2) - (h / 2)
  return window.open(url, title, 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left)
}
